/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileViewsFeature
 */
export interface ProfileViewsFeature {
    /**
     * 
     * @type {number}
     * @memberof ProfileViewsFeature
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileViewsFeature
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileViewsFeature
     */
    abuseContactEmail: string;
}

/**
 * Check if a given object implements the ProfileViewsFeature interface.
 */
export function instanceOfProfileViewsFeature(value: object): value is ProfileViewsFeature {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('abuseContactEmail' in value) || value['abuseContactEmail'] === undefined) return false;
    return true;
}

export function ProfileViewsFeatureFromJSON(json: any): ProfileViewsFeature {
    return ProfileViewsFeatureFromJSONTyped(json, false);
}

export function ProfileViewsFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileViewsFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'limit': json['limit'],
        'abuseContactEmail': json['abuseContactEmail'],
    };
}

export function ProfileViewsFeatureToJSON(value?: ProfileViewsFeature | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'limit': value['limit'],
        'abuseContactEmail': value['abuseContactEmail'],
    };
}

